<svg
	class="search-input-icon"
	aria-hidden="true"
	width="16"
	height="16"
	viewBox="0 0 16 16"
	fill="none"
>
	<circle cx="7" cy="7" r="5" stroke="#595959" stroke-width="1.3" />
	<path
		d="M11 11L14.5 14.5"
		stroke="#595959"
		stroke-width="1.3"
		stroke-linecap="round"
	/>
</svg>

<style>
	.search-input-icon {
		position: absolute;
		left: 12px;
		top: 50%;
		transform: translateY(-50%);
		pointer-events: none;
	}
</style>
